import { IApplicationState } from '../../types/redux';

export function selectMortgageFilterDownPayment(state: IApplicationState) {
  return state.mortgage.filterDownPayment;
}
